export const paises = ["Afeganistão",
    "África do Sul",
    "Albânia",
    "Alemanha",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antártida",
    "Antígua e Barbuda",
    "Arábia Saudita",
    "Argélia",
    "Argentina",
    "Armênia",
    "Aruba",
    "Austrália",
    "Áustria",
    "Azerbaijão",
    "Bahamas",
    "Bahrein",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Bélgica",
    "Belize",
    "Benin",
    "Bermudas",
    "Bolívia",
    "Bósnia-Herzegóvina",
    "Botsuana",
    "Brasil",
    "Brunei",
    "Bulgária",
    "Burkina Fasso",
    "Burundi",
    "Butão",
    "Cabo Verde",
    "Camarões",
    "Camboja",
    "Canadá",
    "Canárias",
    "Cazaquistão",
    "Ceuta e Melilla",
    "Chade",
    "Chile",
    "China",
    "Chipre",
    "Cingapura",
    "Colômbia",
    "Comores",
    "Congo",
    "Coréia do Norte",
    "Coréia do Sul",
    "Costa do Marfim",
    "Costa Rica",
    "Croácia",
    "Cuba",
    "Curaçao",
    "Diego Garcia",
    "Dinamarca",
    "Djibuti",
    "Dominica",
    "Egito",
    "El Salvador",
    "Emirados Árabes Unidos",
    "Equador",
    "Eritréia",
    "Eslováquia",
    "Eslovênia",
    "Espanha",
    "Estados Unidos",
    "Estônia",
    "Etiópia",
    "Fiji",
    "Filipinas",
    "Finlândia",
    "França",
    "Gabão",
    "Gâmbia",
    "Gana",
    "Geórgia",
    "Gibraltar",
    "Grã-Bretanha (Reino Unido, UK)",
    "Granada",
    "Grécia",
    "Groelândia",
    "Guadalupe",
    "Guam (Território dos Estados Unidos)",
    "Guatemala",
    "Guernsey",
    "Guiana",
    "Guiana Francesa",
    "Guiné",
    "Guiné Equatorial",
    "Guiné-Bissau",
    "Haiti",
    "Holanda",
    "Honduras",
    "Hong Kong",
    "Hungria",
    "Iêmen",
    "Ilha Bouvet",
    "Ilha de Ascensão",
    "Ilha de Clipperton",
    "Ilha de Man",
    "Ilha Natal",
    "Ilha Pitcairn",
    "Ilha Reunião",
    "Ilhas Aland",
    "Ilhas Cayman",
    "Ilhas Cocos",
    "Ilhas Cook",
    "Ilhas Faroes",
    "Ilhas Geórgia do Sul e Sandwich do Sul",
    "Ilhas Heard e McDonald (Território da Austrália)",
    "Ilhas Malvinas",
    "Ilhas Marianas do Norte",
    "Ilhas Marshall",
    "Ilhas Menores dos Estados Unidos",
    "Ilhas Norfolk",
    "Ilhas Salomão",
    "Ilhas Seychelles",
    "Ilhas Tokelau",
    "Ilhas Turks e Caicos",
    "Ilhas Virgens (Estados Unidos)",
    "Ilhas Virgens (Inglaterra)",
    "Índia",
    "Indonésia",
    "Inglaterra",
    "Irã",
    "Iraque",
    "Irlanda",
    "Islândia",
    "Israel",
    "Itália",
    "Jamaica",
    "Japão",
    "Jersey",
    "Jordânia",
    "Kiribati",
    "Kosovo",
    "Kuait",
    "Laos",
    "Lesoto",
    "Letônia",
    "Líbano",
    "Libéria",
    "Líbia",
    "Liechtenstein",
    "Lituânia",
    "Luxemburgo",
    "Macau",
    "Macedônia (República Yugoslava)",
    "Madagascar",
    "Malásia",
    "Malaui",
    "Maldivas",
    "Mali",
    "Malta",
    "Marrocos",
    "Martinica",
    "Maurício",
    "Mauritânia",
    "Mayotte",
    "México",
    "Micronésia",
    "Moçambique",
    "Moldova",
    "Mônaco",
    "Mongólia",
    "Montenegro",
    "Montserrat",
    "Myanma",
    "Namíbia",
    "Nauru",
    "Nepal",
    "Nicarágua",
    "Níger",
    "Nigéria",
    "Niue",
    "Noruega",
    "Nova Caledônia",
    "Nova Zelândia",
    "Omã",
    "Países Baixos Caribenhos",
    "Palau",
    "Palestina",
    "Panamá",
    "Papua-Nova Guiné",
    "Paquistão",
    "Paraguai",
    "Peru",
    "Polinésia Francesa",
    "Polônia",
    "Porto Rico",
    "Portugal",
    "Qatar",
    "Quênia",
    "Quirguistão",
    "República Centro-Africana",
    "República Democrática do Congo",
    "República Dominicana",
    "República Tcheca",
    "Romênia",
    "Ruanda",
    "Rússia",
    "Saara Ocidental",
    "Saint-Pierre e Miquelon",
    "Samoa Americana",
    "Samoa Ocidental",
    "San Marino",
    "Santa Helena",
    "Santa Lúcia",
    "São Bartolomeu",
    "São Cristóvão e Névis",
    "São Martim",
    "São Martinho",
    "São Tomé e Príncipe",
    "São Vicente e Granadinas",
    "Senegal",
    "Serra Leoa",
    "Sérvia",
    "Síria",
    "Somália",
    "Sri Lanka",
    "Suazilândia",
    "Sudão",
    "Sudão do Sul",
    "Suécia",
    "Suíça",
    "Suriname",
    "Svalbard",
    "Tadjiquistão",
    "Tailândia",
    "Taiwan",
    "Tanzânia",
    "Território Britânico do Oceano índico",
    "Territórios do Sul da França",
    "Timor-Leste",
    "Togo",
    "Tonga",
    "Trinidad e Tobago",
    "Tristão da Cunha",
    "Tunísia",
    "Turcomenistão",
    "Turquia",
    "Tuvalu",
    "Ucrânia",
    "Uganda",
    "Uruguai",
    "Uzbequistão",
    "Vanuatu",
    "Vaticano",
    "Venezuela",
    "Vietnã",
    "Wallis e Futuna",
    "Zâmbia",
    "Zimbábue",
]